// extracted by mini-css-extract-plugin
export default {"buySellButton":"buySellGroupButton_buySellButton__WB1ne","buy":"buySellGroupButton_buy__yte8P","sell":"buySellGroupButton_sell__u0acp"};